/**
 * List of error codes in the UserManagement module
 *
 */
class UserManagementErrorCode {
    NotCurrentlyLoggedUser = 'user-management/not-currently-logged-user';
}

export default UserManagementErrorCode;